import { handleErrors, SITE_API_URI } from '@service/constants';
import SiteApiClient from '@service/siteApiClient';
import { saveAs } from 'file-saver';
import * as moment from 'moment';

const client = new SiteApiClient(SITE_API_URI);

export function requestLicenseFile(siteName: string, siteId: number, accessToken: string) {
    return new Promise(
        (resolve, reject) => {

            client.getLicenseFile(siteId, accessToken).then((r: any) => r.blob()).then((data: any) => {
                saveAs(data, getFileName(siteName));
            }).catch((err: any) => {
                reject(err);
            });
        }
    );
}

function getFileName(siteName: string) {
    return siteName + '_Licenses_' + moment().format('YYYY_MM_DD_HH_mm') + '.zip';
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/services/siteLicenseDataService.ts